// src/redux/coach/coachSelectors.js

// ✅ Add Coach
export const selectAddCoachData = (state) => state?.coach?.addCoach?.data;
export const selectAddCoachLoading = (state) => state?.coach?.addCoach?.loading;
export const selectAddCoachError = (state) => state?.coach?.addCoach?.error;

// ✅ Update Coach
export const selectUpdateCoachData = (state) => state?.coach?.updateCoach?.data;
export const selectUpdateCoachLoading = (state) => state?.coach?.updateCoach?.loading;
export const selectUpdateCoachError = (state) => state?.coach?.updateCoach?.error;

// ✅ Coach List Paginated
export const selectCoachList = (state) => state?.coach?.getCoachList?.data || [];
export const selectCoachListLoading = (state) => state?.coach?.getCoachList?.loading;
export const selectCoachListError = (state) => state?.coach?.getCoachList?.error;
export const selectCoachListTotal = (state) => state?.coach?.getCoachList?.total || 0;

// ✅ Coach Detail
export const selectCoachDetail = (state) => state?.coach?.getCoachById?.data;
export const selectCoachDetailLoading = (state) => state?.coach?.getCoachById?.loading;
export const selectCoachDetailError = (state) => state?.coach?.getCoachById?.error;

// ✅ Coach List All (no pagination)
export const selectCoachListAll = (state) => state?.coach?.getCoachListAll?.data || [];
export const selectCoachListAllLoading = (state) => state?.coach?.getCoachListAll?.loading;
export const selectCoachListAllError = (state) => state?.coach?.getCoachListAll?.error;

// ✅ Assign Coach
export const selectAssignCoachData = (state) => state?.coach?.assignCoach?.data;
export const selectAssignCoachLoading = (state) => state?.coach?.assignCoach?.loading;
export const selectAssignCoachError = (state) => state?.coach?.assignCoach?.error;

// ✅ Delete Coach
export const selectDeleteCoachData = (state) => state?.coach?.deleteCoach?.data;
export const selectDeleteCoachLoading = (state) => state?.coach?.deleteCoach?.loading;
export const selectDeleteCoachError = (state) => state?.coach?.deleteCoach?.error;

// ✅ Associated Companies
export const selectAssociatedCompanies = (state) => state?.coach?.getAssociatedCompanies?.data || [];
export const selectAssociatedCompaniesLoading = (state) => state?.coach?.getAssociatedCompanies?.loading;
export const selectAssociatedCompaniesError = (state) => state?.coach?.getAssociatedCompanies?.error;

// ✅ Coach companies selectors
export const selectCoachCompanies = (state) => state?.coach?.getCoachCompanies?.data || [];
export const selectCoachCompaniesLoading = (state) => state?.coach?.getCoachCompanies?.loading;
export const selectCoachCompaniesTotal = (state) => state?.coach?.getCoachCompanies?.total || 0;
export const selectCoachCompaniesError = (state) => state?.coach?.getCoachCompanies?.error;

// ✅ NEW: Coach Companies by Month selectors
export const selectCoachCompaniesByMonth = (state) => state?.coach?.getCoachCompaniesByMonth?.data;
export const selectCoachCompaniesByMonthLoading = (state) => state?.coach?.getCoachCompaniesByMonth?.loading;
export const selectCoachCompaniesByMonthError = (state) => state?.coach?.getCoachCompaniesByMonth?.error;

// ✅ Combined
export const selectCoachState = (state) => state?.coach;